import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {filestackUploadPolicy} from 'shared/core';
import {OFFICE_CONTENT_TYPES} from 'shared/constants';
import DOCUMENT_TYPES from 'shared/stores/documents/documentTypes';
import _ from 'lodash';
import prettyBytes from 'pretty-bytes';

class AttachedDocument extends DomainObject {
  id;
  key;
  fileName;
  fileSize;
  contentType;
  label = '';
  previewUrl;
  title; // TODO: remove this after line 42 is fixed
  attachedDocumentId;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      key: observable,
      fileName: observable,
      fileSize: observable,
      contentType: observable,
      label: observable,
      previewUrl: observable,
      title: observable,
      attachedDocumentId: observable,
      preview: computed,
      documentType: computed,
      fileSizeInBytes: computed
    });

    this.merge(other);
  }

  _afterMerge() {
    // TODO: fix this
    const {id, key, label} = this;

    this.attachedDocumentId = id;
    this.id = key;
    this.label = key;
    this.title = label;
  }

  get preview() {
    return this.previewUrl ?
      this.previewUrl : `${this.label}?policy=${filestackUploadPolicy.policy}&signature=${filestackUploadPolicy.signature}`;
  }

  get documentType() {
    if (_.includes(OFFICE_CONTENT_TYPES, this.contentType)) {
      return DOCUMENT_TYPES.OFFICE;
    } else if (this.contentType === 'application/pdf') {
      return DOCUMENT_TYPES.PDF;
    } else {
      return DOCUMENT_TYPES.OTHER;
    }
  }

  get fileSizeInBytes() {
    return prettyBytes(this.fileSize);
  }
}

export default AttachedDocument;
